import { createElement, type ComponentType } from "react";

export const page =
  (load: () => Promise<{ default: ComponentType }>) => async () => ({
    Component: (await load()).default,
  });

export const pageWith =
  <P extends object>(
    load: () => Promise<{ default: ComponentType<P> }>,
    props: P,
  ) =>
  async () => ({ element: createElement((await load()).default, props) });
